<template>
<b-form>
    <otif-textInput v-model="resource.otds_base_uri" label="OTDS Base URL" :disabled="disable_otds_config"/>
    <otif-textInput v-model="resource.otds_resource_id" label="Resource ID" :disabled="disable_otds_config"/>
    <otif-textInput v-model="resource.otds_client_id" label="Client ID" :disabled="disable_otds_config"/>
    <otif-textInput v-model="resource.otds_client_secret" label="Client Secret" :disabled="disable_otds_config"/>
    <otif-textInput v-model="resource.otds_admin_group" label="OTDS Admin Group" :disabled="disable_otds_config" description="Users in this OTDS group will given administrative privileges"/>

   <otif-button  class=" OTPrimary" @click.native="toggleActivation" :disabled="disableActivation">
        <template v-if="otds_activated">
            Deactivate Resource
        </template>
        <template v-else-if="otds_deactivating">
            Deactivating ...
        </template>
        <template v-else-if="otds_activating">
            Activating ...
        </template>
        <template v-else-if="otds_checkingActivation">
            Checking resource status ...
        </template>
        <template v-else>
            Activate Resource
        </template>
    </otif-button>

    <otif-modal v-model="confirmDeactivation" title="Deactivate OTDS Resource">
        <p><strong>WARNING:</strong> Deactivating the OTDS resource will also disable OTDS for authentication. Are you sure you want to continue?</p>
        <template slot="footer">
            <otif-button class=" OTSecondary" @click.native="confirmDeactivation = false">No</otif-button>
            <otif-button class=" OTPrimary" @click.native="deactivate">Yes</otif-button>
        </template>
    </otif-modal>

</b-form>
</template>

<script>

import axios from 'axios';

export default {
    data() {
        return {
            confirmDeactivation: false,
            resource: {
                otds_base_uri: '',
                otds_resource_id: '',
                otds_client_id: '',
                otds_client_secret: '',
                otds_admin_group: '',
                otds_enabled: true
            },
            status: null,
            disableActivation: false,
            otds_activated: false,
            otds_activating: false,
            otds_deactivating: false,
            otds_checkingActivation: false
        }
    },

    computed: {
        disable_otds_config() {
            if (this.otds_activated === true) {
                return true;
            } else {
                return false;
            }
        }
    },

    methods: {

        save() {
            const resource = this.resource;

            this.$snotify.info('Saving OTDS Configuration', { timeout: 0 });


            axios.post('/mtm-gateway-api/v1/configuration/otds', resource)
            .then(() => {
                this.$snotify.clear();
                this.$snotify.success('OTDS Configuration saved.');
            })
            .catch(() => {
                this.$snotify.clear();
                this.$snotify.error('There was an error saving the OTDS configuration.');
            });
        },

        toggleActivation() {
            if (this.otds_activated === true) {
                this.confirmDeactivation = true;
            } else {
                this.activate();
            }
        },

        activate() {

            this.otds_activating = true;
            this.otds_activated = false;
            this.otds_checkingActivation = false;
            this.disableActivation = true;

            this.$snotify.info('Activating Resource', { timeout: 0 });

            const resource = JSON.parse(JSON.stringify(this.resource));
            resource['otds_enabled'] = false;

            axios.post('/mtm-gateway-api/v1/configuration/otds', resource)
            .then((res) => {
                return new Promise((resolve, reject) => {
                    axios.post('/mtm-gateway-api/v1/otds/resource/' + resource.otds_resource_id + '/activate')
                    .then(() => {
                        this.refresh_otds_status()
                        .then(() => {
                            resolve();
                        })
                        .catch((err) => {
                            reject(err);
                        });
                    })
                    .catch((err) => {
                        reject(err);
                    });
                });
            })
            .then(() => {
                resource['otds_enabled'] = true;
                return axios.post('/mtm-gateway-api/v1/configuration/otds', resource);
            })
            .then((res) => {
                this.resource = res.data;
                this.$snotify.clear();
                this.$snotify.success('OTDS Activated and now enabled', 'OTDS');
            })
            .catch((err) => {
                this.$snotify.clear();
                this.$snotify.error('There was an error activating the OTDS resource', 'Error');
                this.refresh_otds_status();
            });

            /*
            axios.post('/mtm-gateway-api/v1/otds/resource/' + this.resource.otds_resource_id + '/activate')
            .then((res) => {
                return this.refresh_otds_status();
            })
            .catch((err) => {
                this.otds_activating = false;
                this.otds_activated = false;
                this.disableActivation = false;
                this.$snotify.clear();
                this.$snotify.error(err.response.data.detail, 'Error');
            });
            */
        },

        deactivate() {

            this.$snotify.info('Deactivating Resource', { timeout: 0 });

            this.otds_activating = false;
            this.otds_deactivating = true;
            this.otds_activated = false;
            this.otds_checkingActivation = false;
            this.disableActivation = true;

            axios.post('/mtm-gateway-api/v1/otds/resource/' + this.resource.otds_resource_id + '/deactivate')
            .then((res) => {

                this.resource.otds_enabled = 'false';

                return axios.post('/mtm-gateway-api/v1/configuration/otds', this.resource)
                .then(() => {
                    this.$snotify.clear();
                    this.$snotify.success('Resource Deactivated');
                    this.otds_activated = false;
                    this.otds_deactivating = false;
                    this.otds_activating = false;
                    this.otds_checkingActivation = false;
                })
                .catch((err) => {
                    this.otds_activated = true;
                    this.otds_deactivating = false;
                    this.otds_activating = false;
                    this.otds_checkingActivation = false;
                    this.$snotify.clear();
                    this.$snotify.error('There was an error trying to deactivate the resource.');
                });
            })
            .catch((err) => {
                this.$snotify.clear();
                this.$snotify.error('There was an error trying to deactivate the resource.');
                this.otds_activated = true;
                this.otds_deactivating = false;
                this.otds_activating = false;
                this.otds_checkingActivation = false;
            })
            .then(() => {
                this.confirmDeactivation = false;
                this.disableActivation = false;
            });

        },

        async refresh_otds_status() {
            this.status = null;

            if (!this.resource.otds_resource_id) {
                this.otds_activated = false;
                this.otds_activating = false;
                this.otds_checkingActivation = false;
                this.disableActivation = false;
            } else {
                return axios.post('/mtm-gateway-api/v1/otds/resource/' + this.resource.otds_resource_id + '/status')
                .then((res) => {
                    if (res.data === true) {
                        this.otds_activated = true;
                        this.otds_activating = false;
                        this.otds_checkingActivation = false;
                        this.disableActivation = false;
                    } else {
                        this.otds_activated = false;
                        this.otds_activating = false;
                        this.otds_checkingActivation = false;
                        this.disableActivation = false;
                    }
                });
            }
        },

        async refresh_otds() {

            this.otds_activated = false;
            this.otds_activating = false;
            this.otds_checkingActivation = true;
            this.disableActivation = true;

            const res = await axios.get('/mtm-gateway-api/v1/configuration/otds')
            this.resource = res.data;
            this.otds_loaded = true;
            await this.refresh_otds_status();
        }
    },

    mounted() {
        this.refresh_otds();
    }
}
</script>
